/* Garage page — hydrates the saved scooter into the hero and forces the
 * garage filter ON so the grid only shows compatible parts.
 *
 * Works alongside garage-filter.js — that script handles the actual hide/show
 * logic on `[data-collection-grid]`; we just flip its sessionStorage toggle
 * to ON when the page loads with a saved scooter.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'evscooter:garage:v1';
  const TOGGLE_KEY = 'evscooter:garage:filter-on';

  const root = document.querySelector('[data-garage-page]');
  if (!root) return;

  const els = {
    hero: root.querySelector('[data-garage-hero]'),
    empty: root.querySelector('[data-garage-hero-empty]'),
    filled: root.querySelector('[data-garage-hero-filled]'),
    name: root.querySelector('[data-garage-hero-name]'),
    subtitle: root.querySelector('[data-garage-hero-subtitle]'),
    open: root.querySelector('[data-garage-page-open]'),
    clear: root.querySelector('[data-garage-page-clear]'),
    gridWrap: root.querySelector('[data-garage-page-grid-wrap]'),
  };

  function readGarage() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null; } catch (_) { return null; }
  }

  function render() {
    const scooter = readGarage();
    if (scooter && scooter.variantName) {
      els.empty.setAttribute('hidden', '');
      els.filled.removeAttribute('hidden');
      els.name.textContent = scooter.variantName;
      els.subtitle.textContent = els.subtitle.dataset.filled
        || els.subtitle.textContent;
      els.clear.removeAttribute('hidden');
      els.gridWrap.removeAttribute('hidden');
      sessionStorage.setItem(TOGGLE_KEY, '1');
      els.open.textContent = els.open.dataset.changeText || els.open.textContent;
    } else {
      els.empty.removeAttribute('hidden');
      els.filled.setAttribute('hidden', '');
      els.clear.setAttribute('hidden', '');
      els.gridWrap.setAttribute('hidden', '');
      sessionStorage.setItem(TOGGLE_KEY, '0');
    }
    // Tell the collection filter to re-read the toggle and re-apply. Without
    // this signal the filter only re-runs on `garage:change`, so on initial
    // /pages/meine-teile load it would apply BEFORE we set the toggle to '1'
    // and stay in "Filter aus" state.
    document.dispatchEvent(new CustomEvent('garage:refresh', { detail: scooter }));
  }

  // Strings injected by snippets/garage-i18n.liquid (translatable per locale
  // via Shopify Admin → Translations). German fallback for safety only.
  const I18N = window.evGarageI18n || {};
  els.subtitle.dataset.empty = els.subtitle.textContent.trim();
  els.subtitle.dataset.filled = I18N.pageSubtitleFilled
    || 'Wir zeigen dir nur Teile, die zu deinem Scooter passen.';
  els.open.dataset.changeText = I18N.changeScooter
    || 'Anderen Scooter wählen';

  els.open.addEventListener('click', () => {
    if (window.evGarage && typeof window.evGarage.open === 'function') {
      window.evGarage.open();
    }
  });

  els.clear.addEventListener('click', () => {
    if (window.evGarage && typeof window.evGarage.clear === 'function') {
      window.evGarage.clear();
    } else {
      localStorage.removeItem(STORAGE_KEY);
      document.dispatchEvent(new CustomEvent('garage:change'));
    }
  });

  document.addEventListener('garage:change', render);
  render();
})();
